export default __webpack_public_path__ + "static/media/ico_prescriptions.d91f33c1.svg";